import { z } from 'zod'

const envSchema = z.object({
  VITE_API_URL: z.string().url(),

  VITE_HUB_ROUTE: z.string().url(),

  VITE_ENABLE_DELAY: z.coerce.boolean().default(false),

  VITE_HOTEL_IMAGES_URL: z.string().url(),
  VITE_HOTEL_UH_IMAGES_URL: z.string().url(),
  VITE_AGENCY_SALE_POINT_IMAGES_URL: z.string().url(),

  VITE_GOOGLE_MAP_KEY: z.string().optional(),

  VITE_COGNITO_APP_CLIENT_ID: z.string(),
  VITE_COGNITO_USER_POOL_ID: z.string(),

  VITE_API_TEST_URL: z.string(),
  VITE_AWS_REGION: z.string(),

  VITE_ENV: z.enum(['dev', 'production', 'homolog', 'internal']),

  VITE_ZENDESK_KEY: z.string().optional(),
  VITE_GOOGLE_TAG_MANAGER_KEY: z.string().optional(),
  VITE_HOTJAR_KEY: z.string().optional(),
  VITE_ENABLE_MSW: z.coerce.boolean().optional(),
  VITE_COGNITO_COOKIE_DOMAIN: z.string().optional(),

  VITE_SENTRY_DSN: z.string().optional(),
  VITE_MICROSOFT_CLARITY_KEY: z.string().optional(),
})

const parsedEnv = envSchema.safeParse(import.meta.env)

if (parsedEnv.success === false) {
  console.error(
    '❌ Invalid environment variables.',
    parsedEnv.error.flatten().fieldErrors,
  )

  throw new Error('Invalid environment variables.')
}

export const env = parsedEnv.data
